import { useEffect, useState } from 'react';
import sessionTimeoutMessage from './timeoutMessage';

const {tableau} = window;

const VizDiv = ({url, vizRef, handleSwitch}) => {
    const [newViz, setViz] = useState(null);

    const initViz = () => {
        let containerDiv = document.getElementById("tableauContainer");
        const options = {
                id:"tableauViz",
                src:{url},
                device:"default",
                toolbar:"hidden",
                height:"900px",
                width:"1600px",

                onFirstInteractive: () => {
                    console.log('Viz Tab Switched');
                    onhandleSwitch();
                }
        };

        const viz = new tableau.Viz(containerDiv, url, options);
        setViz(viz);

        const onhandleSwitch = () => {
            viz.addEventListener(tableau.TableauEventName.TAB_SWITCH, {handleSwitch});
        };
    };

    useEffect(() => {
        const timer = sessionTimeoutMessage();
        initViz();
        return () => {
            console.log("unmounting...");
            clearTimeout(timer);
        };
    }, []);

    return(
        <>
            <div>
                <div id="tableauContainer"></div>
            </div>
        </>
    );
}

export default VizDiv;